
import { Calendar } from "@/components/ui/calendar";
import { format } from "date-fns";
import { da } from "date-fns/locale";
import TaskCard from "../TaskCard";

interface Task {
  id: string;
  title: string;
  status: string;
  assignedTo: string;
  date: string;
  location: string;
  priority: string;
  estimatedHours: number;
  taskType: string;
  createdByType: string;
}

interface CalendarViewProps {
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  tasksForDate: Task[];
  onEdit: (taskId: string) => void;
  onDelete: (taskId: string) => void;
}

const CalendarView = ({ 
  selectedDate, 
  setSelectedDate, 
  tasksForDate,
  onEdit,
  onDelete 
}: CalendarViewProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={(date) => date && setSelectedDate(date)}
          locale={da}
          className="rounded-md border"
        />
      </div>
      <div>
        <h3 className="text-lg font-medium mb-4">
          Opgaver for {format(selectedDate, "d. MMMM yyyy", { locale: da })}
        </h3>
        <div className="space-y-4">
          {tasksForDate.length === 0 ? (
            <p className="text-muted-foreground">
              Ingen opgaver planlagt for denne dato
            </p>
          ) : (
            tasksForDate.map((task) => (
              <TaskCard 
                key={task.id} 
                task={{
                  ...task,
                  status: task.status as "pending" | "in-progress" | "completed",
                  priority: task.priority as "low" | "medium" | "high",
                  taskType: task.taskType as "installation" | "repair" | "inspection" | "maintenance",
                  createdByType: task.createdByType as "admin" | "employee"
                }}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarView;
